import now from "./now";
import startOfDay from "../owaDate/startOfDay";
import type { OwaDate } from "../schema";

export default (): OwaDate => startOfDay(now());
